// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"form-view_shadow__1EDI9","form":"form-view_form__3mQYv","input":"form-view_input__3489W"};